import { render, staticRenderFns } from "./LingboView.vue?vue&type=template&id=0eca71ae&scoped=true&"
import script from "./LingboView.vue?vue&type=script&lang=js&"
export * from "./LingboView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eca71ae",
  null
  
)

export default component.exports